export default "/_next/static/images/8bbebfaf53e43e1132ae553000e0bab4.jpg";